import {showToast, Toast} from "vant";
import { RED_GROUP_MIN_APP_VERSION } from '@/constants/appConfig'

export var appEvent = window.actionlistner || window.imagelistner;


export function getDeviceInfoSdk(appId,appSecret,userId,headImage,nickName) {
    if (appEvent) {
        const data = appEvent.getDeviceInfoSdk(appId,appSecret,userId,headImage,nickName);
        return JSON.parse(data);
    } else {
        let appDatas = {
            "userDevice": {
                "appSecret": "3hu25dzm2vpq7v691u1oo0eo4am79ks7",
                "appId": "sdkqiangdanya",
                "thirdUserId": "2032286446192861185",
                "oaId": "uwiieieuuruh",
                "versionCode": 110,
                "versionName": "1.1.0",
                "hostVersionCode": 1,
                "hostVersionName": "1.0",
                "cacheOaid": "uwiieieuuruh",
                "imei1": "null", "imei2": "",
                "deviceId": "uwiieieuuruh", "androidId": "1687a0d5ecc21ec8",
                "androidVersion": "12", "sdkVersion": "31",
                "bluetooth": "02:00:00:00:00:00", "brand": "Redmi", "buildId": "SP1A.210812.016",
                "mobileversion": "M2103K19C", "model": "M2103K19C", "networkCountryIso": "cn",
                "connectionType": 5, "display": "AN3516-camellia-build-20221128115810", "developerStatus": 0,
                "fingerPrint": "Redmi/camellia/camellia:12/SP1A.210812.016/V13.0.9.0.SKSCNXM:user/release-keys",
                "networkRoaming": 0, "phoneType": 1, "simOperatorName": "中国移动", "simState": "1", "smCard": "",
                "subscriberId": "", "host": "non-pangu-pod-j90gm", "width": 1080, "height": 2400, "densityDpi": 0,
                "mnv": "46002", "mobileBaseStationCode": "", "wifiName": "<unknown ssid>", "simSerialNumber": "",
                "rootFlag": 0, "drmId": "uqiQcl2QFTTESd3W6RWyLRiJbF7lqo7k8Eb7LhnNWEw=", "cpuName": "0", "mac": "null",
                "mobileMac": "null", "simulatorFlag": 0, "mzqId": "60096d76bbad5094b09b1d87d9602c09", "appPackageName": "com.example.mtjtrwapp",
                "os": "Android", "appMd5Sign": "05e04687f74c095bc020465b3b434a6b", "noticeBarAuthFlag": 1, "vpn": 0, "agencyNet": 0, "flightMode": 0,
                "batteryStatus": 3, "batterLevel": 353, "batteryTechnology": 0, "batteryVoltage": 3920, "batteryTemperature": 81,
                "dnsServiceAddress": "[/2409:8088::8, /2409:8088::9, /211.138.21.66, /211.138.23.66]",
                "netLinkAddress": "10.98.13.109/32,2409:894a:3b9:897:187f:85a7:3640:c0b8/64", "netInterfaceName": "ccmni1", "cpu": 0, "emuCount": 0,
                "inIp": "0.0.0.0", "getSerial": "", "product": "camellia", "simulatorName": "", "uuid": "ffffffff-d892-82ba-0000-000000000000",
                "storageTotalSize": "244 ", "storageSysUseSize": "202 ", "storageSdUseSize": "202 ",
                "storageRamSize": "8GB", "storageRamTotalSize": "256GB", "storageRunSize": "5.04 ", "storageRunTotalSize": "8.00 ",
                "storageTotalUseSize": 232877
            },
            "channelId": "sdkqiangdanya",
            "thirdUserId": "2032286446192861185",
            "orginChannel": "sdk"
        }
        return appDatas
    }
}

/**
 * 微信授权登录 - 调用原生方法拉起微信授权
 * @param {string} funcName - 回调方法名称字符串，必须能在全局window上找到对应函数
 * 原生授权成功后会调用 window[funcName](data) 或类似方式传递授权信息
 * data格式: {code: 1, msg: '', wxInfo: {city, country, headimgurl, nickname, openid, province, sex, unionid, language}}
 * code=1成功，0失败。成功后需映射到wechatUserInfo格式调用登录接口
 */
export function wxAuth(funcName) {
    if (appEvent) {
        console.log('调用原生微信授权，回调函数名:', funcName);
        appEvent.wxAuth(funcName);
    } else {
        console.log('非App环境，模拟微信授权回调');
        // Mock for development - simulate successful auth
        setTimeout(() => {
            if (window[funcName.replace('window.', '')]) {
                const mockData = {
                    code: 1,
                    msg: "授权成功",
                    wxInfo: {
                        city: "北京",
                        country: "中国",
                        headimgurl: "https://thirdwx.qlogo.cn/mmopen/vi_32/ZF92pU9NOJZ1GsEzpibKIk003XQY9PGgibLG89QPvolPK9icN4kv7sAIiaEARPwwquGwYeqGsibibtJviaAmlXHwDpibJA/132",
                        language: "zh_CN",
                        nickname: "测试用户7",
                        openid: "onSly2UoQa49l55VRhKkjfs0YJ907",
                        province: "北京",
                        sex: "0",
                        unionid: "oqtFx2QQaI9lW_8ZDxTHh16hNMhU7"
                    }
                };
                window[funcName.replace('window.', '')](mockData);
            }
        }, 800);
    }
}

/**
 * 拉起微信商家转账用户确认页（原生 wxOpenBusiness / WXOpenBusinessView.requestMerchantTransfer）
 * 按微信支付文档，query 中各参数的 value 需 UrlEncode；此处对 package_info 做 encodeURIComponent，
 * 避免 +、/、= 等在传输或解析时被误判导致「package_info 有误」。
 * 注意：Android 侧应将此字符串作为已编码的 package 值拼入 query，不要再对 package 二次编码。
 * @param {string} packageInfo 发起转账接口返回的 package_info（原始串，非已编码）
 */
export function openWxMiniPay(packageInfo) {
    if (!appEvent) {
        return;
    }
    const raw = typeof packageInfo === 'string' ? packageInfo.trim() : String(packageInfo || '').trim();
    if (!raw) {
        return;
    }
    const encodedPackage = encodeURIComponent(raw);
    appEvent.wxOpenBusiness("1744280317", encodedPackage);
}


export function openMzqSdk(appId,appSecret,userId,headImage,nickName,token) {
    console.log("openMzqSdk",userId);
    if (appEvent) {
        if(getAppFixedParams().appVersion > 100){
            appEvent.openMzqSdk(appId,appSecret,userId,headImage,nickName,token);
        }else{
            appEvent.openMzqSdk(appId,appSecret,userId,headImage,nickName);
        }
    }
}

export function openMzqSdkMyTask(appId,appSecret,userId,headImage,nickName,token) {
    if (appEvent) {
        if(getAppFixedParams().appVersion > 100){
            appEvent.openMzqSdkMyTask(appId,appSecret,userId,headImage,nickName,token);
        }else{
            appEvent.openMzqSdkMyTask(appId,appSecret,userId,headImage,nickName);
        }
    }
}

export function startPage(url) {
    if (appEvent) {
        appEvent.startPage(url);
    }
}

export function openLinkDirect(url) {
    if (appEvent) {
        appEvent.openLinkDirect(url);
    }
}
//传入权限名称，调用原始方法获取权限状态, true：有权限 false：无权限
export function checkAppPermission(perName) {
    if (appEvent) {
       return appEvent.checkAppPermission(perName);
    }
    return true;
}
//请求权限
export function requestAppPermission(perName) {
    if (appEvent) {
        appEvent.requestAppPermission(perName);
    }
}

export function aliAuth(authInfo, callbackName) {
    if (!appEvent) {
        return;
    }
    appEvent.authByAli(authInfo, callbackName);
}

export function goBack() {
    if (appEvent) {
        appEvent.goBack();
    }else {
        history.back(-1);
    }
}

export function putString(key,data) {
    if (appEvent) {
        appEvent.putString(key,data);
    }
}

/**
 * 从安卓原生读取字符串存储（与 putString 成对）
 * @param {string} key 存储键，如 androidUserInfo / androidToken
 * @returns {string} 无数据或非 App 环境返回空字符串
 */
export function getString(key) {
    if (appEvent && typeof appEvent.getString === 'function') {
        try {
            const v = appEvent.getString(key)
            return v == null ? '' : String(v)
        } catch (e) {
            console.error('getString 原生调用异常:', e)
            return ''
        }
    }
    return ''
}

export function openMzqSdkDetails(appId,appSecret,userId,headImage,nickName,url,token) {
    if (appEvent) {
        if(getAppFixedParams().appVersion > 100){
            appEvent.openMzqSdkDetails(appId,appSecret,userId,headImage,nickName,url,token);
        }else{
            appEvent.openMzqSdkDetails(appId,appSecret,userId,headImage,nickName,url);
        }

    }
}

/**
 * 获取aso sdk访问地址
 */
export function getAsoSdkTaskUrl() {
    if (appEvent) {
        return appEvent.getAsoSdkTaskUrl();
    }
}

/**
 * 关闭当前页面
 */
export function finishPage() {
    if (appEvent) {
        appEvent.finishPage();
    } else {
        window.history.back(-1);
        Toast('请在APP中使用')
    }
}

/**
 * 从安卓原生获取app参数
 */
export function getAppFixedParams() {
    if (appEvent) {
        return JSON.parse(appEvent.getAppFixedParams());
    } else {
        return {
            appVersionName: '1.0.3',
            // >=103 支持微信授权 mock；>=104 支持广告桥接 mock（与真实端能力对齐，便于浏览器联调）
            appVersion: '104',
            appName: 'app名称',
        }
    }
}

/**
 * 检查当前APP版本是否支持微信授权登录
 * 只有 >= 103版本的APP才提供了wxAuth原生方法
 * @returns {boolean} 是否支持微信授权
 */
export function checkWechatSupport() {
    try {
        const params = getAppFixedParams();
        const version = parseInt(params.appVersion || 100, 10);
        console.log('当前APP版本:', version, '是否支持微信授权:', version >= 103);
        return version >= 103;
    } catch (e) {
        console.error('版本检查失败:', e);
        return false; // 保守处理
    }
}

/**
 * 清楚webview缓存
 */
export function clearWebCache() {
    if (appEvent) {
        appEvent.clearWebCache();
    }
}
//获取邀请链接
export function getAsoAppInviteUrl() {
    if (appEvent) {
        return appEvent.getAsoAppInviteUrl();
    }else{
        return "baidu"
    }
}


/**
 * 从安卓原生获取设备参数
 */
export function getDeviceInfoSimple() {
    if (appEvent) {
        return JSON.parse(appEvent.getDeviceInfoSimple());
    }else{
        return {
            symbolCode: "",
            deviceSystem: "Android",
            appVersion: 100,
            patchVersion: "",
            appName: "抢单鸭",
            appId: "",
            channel: "qdy_st",
            model: "VOG-AL00",
            appVersionName: "1.0.0",
            brand: "HUAWEI",
            deviceId: "311632c3-205d-4974-9f2c-345f5af9117f"
        }
    }
}

/**
 * 复制文本到剪切板
 * @param {*} text 要复制的内容
 * @param {*} onC 复制成功回调
 * @param {*} onE 复制失败回调
 */
/**
 * 防连续点击：2秒内只允许触发一次
 * @param {Function} fn 要执行的函数
 * @param {number} delay 间隔毫秒，默认2000
 * @returns {Function}
 */
export function throttleClick(fn, delay = 2000) {
    let lastTime = 0
    return function (...args) {
        const now = Date.now()
        if (now - lastTime < delay) return
        lastTime = now
        return fn.apply(this, args)
    }
}

/**
 * 计算字符串 hashCode（与 Java 端保持一致）
 */
function hashCode(str) {
    let hash = 0
    for (let i = 0; i < str.length; i++) {
        hash = Math.imul(31, hash) + str.charCodeAt(i) | 0
    }
    return hash
}

/**
 * 根据任务 ID 返回对应本地图标路径（taskIcon0 ~ taskIcon9）
 */
export function getTaskIcon(taskId) {

    const index = Math.abs(hashCode(String(taskId)) % 10)
    return require(`@/assets/icons/taskIcon${index}.png`)
}

/**
 * 从本地缓存读取当前登录用户 userId（字段兼容 userId / userid / id，与业务侧习惯一致）
 * @returns {string} 未登录或解析失败时返回空字符串
 */
export function getStoredUserId() {
    try {
        // 本地无数据时从原生 androidUserInfo 恢复（域名切换后 localStorage 可能被清空）
        let raw = localStorage.getItem('userInfo')
        if (!raw) {
            raw = getString('androidUserInfo')
            if (raw) {
                localStorage.setItem('userInfo', raw)
            }
        }
        if (!raw) return ''
        const o = JSON.parse(raw)
        const id = o.userId ?? o.userid ?? o.id
        return id === undefined || id === null ? '' : String(id)
    } catch {
        return ''
    }
}

/**
 * 从本地缓存读取当前登录 token（与 http 拦截器 / Login.vue 保持一致）
 * 本地无 token 时尝试从原生 androidToken 读取并回填 localStorage
 * @returns {string} 未登录或解析失败时返回空字符串
 */
export function getStoredToken() {
    try {
        let token = localStorage.getItem('token') || ''
        if (!token) {
            token = getString('androidToken')
            if (token) {
                localStorage.setItem('token', token)
            }
        }
        return token
    } catch {
        return ''
    }
}

/**
 * 将当前登录用户的 userId 与 token 透传给原生端
 * 调用时机：登录成功后 / 已登录态进入 Home / 退出登录（双双传空字符串）
 * 端上原生方法：appEvent.setAppUserId(userId, token)
 *
 * 注意：与广告桥接不同，本方法不强制 App >= 104 版本号校验，仅检查原生方法是否存在；
 * 端上未实现时静默跳过，返回 false。允许 userId / token 为空字符串
 * （由原生侧据此清理本地用户标识缓存）。
 *
 * @param {string} userId 当前登录用户 ID（未登录传 ''）
 * @param {string} token 当前登录 token（未登录传 ''）
 * @returns {boolean} 已成功透传为 true；原生未实现 / 调用异常为 false
 */
export function setAppUserId(userId, token) {
    const uid = String(userId ?? '').trim()
    const tk = String(token ?? '').trim()
    if (appEvent && typeof appEvent.setAppUserId === 'function') {
        try {
            appEvent.setAppUserId(uid, tk)
            return true
        } catch (e) {
            console.error('setAppUserId 原生调用异常:', e)
            return false
        }
    }
    console.log('非 App 或未实现 setAppUserId，跳过（模拟环境）', { userId: uid, hasToken: !!tk })
    return false
}

/**
 * 打开原生红包群页面
 * @returns {boolean} 已成功调起原生方法为 true；非 App 或未实现为 false
 */
export function openRedGroup() {
    if (appEvent && typeof appEvent.openRedGroup === 'function') {
        try {
            appEvent.openRedGroup()
            return true
        } catch (e) {
            console.error('openRedGroup 原生调用异常:', e)
            return false
        }
    }
    console.log('非 App 或未实现 openRedGroup，跳过（模拟环境）')
    return false
}

/**
 * 红包群功能需 App build >= RED_GROUP_MIN_APP_VERSION（当前 106）；低于该版本点击入口弹升级窗
 * @returns {boolean} true 表示当前版本可调用 openRedGroup
 */
export function isRedGroupFeatureSupported() {
    try {
        const params = getAppFixedParams()
        const version = parseInt(String(params.appVersion ?? '0'), 10)
        return !Number.isNaN(version) && version >= RED_GROUP_MIN_APP_VERSION
    } catch (e) {
        console.error('红包群功能版本检查失败:', e)
        return false
    }
}


/**
 * 激励/插屏广告相关原生桥接仅 App build >= 104 提供；低于该版本端上无对应方法，调用会异常。
 * `loadRewardAd`、`loadInsterAd`、`loadReInsterAd`、`checkInsterIsAdReady`、`showInsterAd` 均依赖此判断。
 * @returns {boolean} true 表示当前版本可安全调用上述广告 API
 */
export function isNativeAdBridgeSupported() {
    try {
        const params = getAppFixedParams()
        const version = parseInt(String(params.appVersion ?? '0'), 10)
        return !Number.isNaN(version) && version >= 104
    } catch (e) {
        console.error('广告桥接版本检查失败:', e)
        return false
    }
}

/**
 * 解析原生传入的回调函数名（支持传 "foo" 或 "window.foo"）
 * @param {string} funcName 回调方法名称
 * @returns {string} 挂载在 window 上的属性名
 */
function resolveAdCallbackKey(funcName) {
    if (typeof funcName !== 'string') return ''
    return funcName.replace(/^window\./, '').trim()
}

/**
 * 非 App 或无对应桥接时，模拟广告生命周期回调（便于 H5 联调）
 * @param {string} funcName 全局回调名
 * @param {boolean} isRewardVideo 是否激励视频（为 true 时会多一步 onRewardEcpm，且带示例 adInfo）
 */
function simulateAdCallbacks(funcName, isRewardVideo = false) {
    const key = resolveAdCallbackKey(funcName)
    const cb = key && window[key]
    if (typeof cb !== 'function') return
    /** 基础步骤（插屏与激励共用） */
    const steps = [
        { status: 'onADReceiv', message: '', adInfo: {} },
        { status: 'onReward', message: '', adInfo: {} },
    ]
    // 激励视频：在 onReward 之后增加 eCPM 回调（原生会带 adInfo，联调时用示例字段）
    if (isRewardVideo) {
        steps.push({
            status: 'onRewardEcpm',
            message: '',
            adInfo: { ecpm: 12.34, networkName: 'mock_network', creativeId: 'mock-creative-id' },
        })
    }
    steps.push(
        { status: 'onVideoComplete', message: '', adInfo: {} },
        { status: 'onADClose', message: '', adInfo: {} },
    )
    steps.forEach((payload, i) => {
        setTimeout(() => {
            try {
                cb(JSON.stringify(payload))
            } catch (e) {
                console.error('模拟广告回调失败', e)
            }
        }, 350 * (i + 1))
    })
}

/**
 * 调用原生加载激励视频广告
 * 原生通过 funcName 对应的全局方法回调生命周期，入参为 JSON 字符串或对象（与端上约定一致即可）
 * @param {string} adId 广告位 ID
 * @param {string} funcName 广告回调方法名称（需在 window 上可访问）
 * @param {string} userId 当前登录用户 userId
 * 回调数据示例：{ status, message, adInfo }
 * status：onADReceiv 加载成功；onReward 激励发放；onRewardEcpm 激励 eCPM（带 adInfo）；onVideoComplete 播放结束；onADClose 关闭；onADFailed 失败
 * @returns {boolean} 已发起加载或模拟则为 true；App 版本不足 104 不支持广告时为 false
 */
export function loadRewardAd(adId, funcName, userId) {
    if (!isNativeAdBridgeSupported()) {
        console.warn('当前 App 版本 < 104，不支持 loadRewardAd')
        return false
    }
    const id = String(adId ?? '')
    const fn = String(funcName ?? '')
    const uid = String(userId ?? '')
    if (appEvent && typeof appEvent.loadRewardAd === 'function') {
        appEvent.loadRewardAd(id, fn, uid)
    } else {
        console.log('非 App 或未实现 loadRewardAd，走模拟回调', { adId: id, funcName: fn })
        simulateAdCallbacks(fn, true)
    }
    return true
}

/**
 * 调用原生加载插屏广告（入参与回调语义同激励视频）
 * @param {string} adId 广告位 ID
 * @param {string} funcName 广告回调方法名称
 * @param {string} userId 当前登录用户 userId
 * @returns {boolean} 已发起加载或模拟则为 true；App 版本不足 104 时为 false
 */
export function loadInsterAd(adId, funcName, userId) {
    if (!isNativeAdBridgeSupported()) {
        console.warn('当前 App 版本 < 104，不支持 loadInsterAd')
        return false
    }
    const id = String(adId ?? '')
    const fn = String(funcName ?? '')
    const uid = String(userId ?? '')
    if (appEvent && typeof appEvent.loadInsterAd === 'function') {
        appEvent.loadInsterAd(id, fn, uid)
    } else {
        console.log('非 App 或未实现 loadInsterAd，走模拟回调', { adId: id, funcName: fn })
        simulateAdCallbacks(fn)
    }
    return true
}

/** 非原生环境：预加载插屏模拟「已就绪」标记（onADReceiv 模拟结束后置 true，供 checkInsterIsAdReady 联调） */
let mockPreloadInterReady = false

/**
 * 调用原生预加载插屏广告（入参、回调 JSON 与 loadInsterAd 一致）
 * @param {string} adId 广告位 ID
 * @param {string} funcName 广告回调方法名称
 * @param {string} userId 当前登录用户 userId
 * @returns {boolean} 已发起预加载或模拟则为 true；App 版本不足 104 时为 false
 */
export function loadReInsterAd(adId, funcName, userId) {
    if (!isNativeAdBridgeSupported()) {
        console.warn('当前 App 版本 < 104，不支持 loadReInsterAd')
        return false
    }
    const id = String(adId ?? '')
    const fn = String(funcName ?? '')
    const uid = String(userId ?? '')
    if (appEvent && typeof appEvent.loadReInsterAd === 'function') {
        appEvent.loadReInsterAd(id, fn, uid)
    } else {
        console.log('非 App 或未实现 loadReInsterAd，走模拟回调', { adId: id, funcName: fn })
        mockPreloadInterReady = false
        simulateAdCallbacks(fn)
        // 模拟首帧加载成功后再允许「已准备好」（步长与 simulateAdCallbacks 内延迟对齐）
        const stepMs = 350
        const stepsBeforeReady = 1
        setTimeout(() => {
            mockPreloadInterReady = true
        }, stepMs * stepsBeforeReady + 50)
    }
    return true
}

/**
 * 检测预加载的插屏广告是否已准备好（原生直接返回布尔）
 * @returns {boolean} true 已准备好；false 未准备好、或 App 版本不足 104（视为不支持）
 */
export function checkInsterIsAdReady() {
    if (!isNativeAdBridgeSupported()) {
        return false
    }
    if (appEvent && typeof appEvent.checkInsterIsAdReady === 'function') {
        const ret = appEvent.checkInsterIsAdReady()
        if (typeof ret === 'boolean') return ret
        if (typeof ret === 'string') {
            const s = ret.trim().toLowerCase()
            return s === 'true' || s === '1'
        }
        return !!ret
    }
    return mockPreloadInterReady
}

/**
 * 展示已预加载的插屏广告（需先预加载且 checkInsterIsAdReady 为 true）
 * @returns {boolean} 已调起展示（含模拟）为 true；App 版本不足 104 为 false
 */
export function showInsterAd() {
    if (!isNativeAdBridgeSupported()) {
        console.warn('当前 App 版本 < 104，不支持 showInsterAd')
        return false
    }
    if (appEvent && typeof appEvent.showInsterAd === 'function') {
        appEvent.showInsterAd()
    } else {
        console.log('非 App 或未实现 showInsterAd，模拟展示预加载插屏')
        mockPreloadInterReady = false
    }
    return true
}

/**
 * 将开屏广告位 ID 透传给原生端（原生收到后用于下次启动开屏广告加载）
 * 端上原生方法：appEvent.setSpAdId(adId)
 * 与其它广告桥接保持一致，仅在 App >= 104 时调用；
 * 非 App 或端上未实现该方法时静默跳过，返回 false。
 *
 * 注意：允许 adId 为空字符串。业务约定当广告位 adStatus=0 / adId 为空 /
 * 配置未返回该 adCode 时，传空字符串通知原生清理本地缓存（不再展示开屏）。
 *
 * @param {string} adId 开屏广告位 ID（可为空字符串）
 * @returns {boolean} 已成功透传为 true；版本不支持 / 端上无该方法为 false
 */
export function setSpAdId(adId) {
    const id = String(adId ?? '').trim()
    if (!isNativeAdBridgeSupported()) {
        console.warn('当前 App 版本 < 104，不支持 setSpAdId')
        return false
    }
    if (appEvent && typeof appEvent.setSpAdId === 'function') {
        try {
            appEvent.setSpAdId(id)
            return true
        } catch (e) {
            console.error('setSpAdId 原生调用异常:', e)
            return false
        }
    }
    console.log('非 App 或未实现 setSpAdId，跳过（模拟环境）', { adId: id })
    return false
}

export function copyText(text, onC, onE) {
    var textArea = document.createElement("textarea");
    textArea.style.position = 'fixed';
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.width = '2em';
    textArea.style.height = '2em';
    textArea.style.padding = '0';
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    textArea.style.background = 'transparent';
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    try {
        var successful = document.execCommand('copy');
        if (successful) {
            if (onC) onC();
        } else {
            if (onE) onE();
        }
        showToast('复制成功!')
    } catch (err) {
        if (onE) onE();
    }
    document.body.removeChild(textArea);
}



